import { PROPERTY_CODE_LABELS } from "src/constants/properties";
import { useT } from "src/internationalization";
import { PropertyCode } from "src/types/property";

export const useGetPropertyLabel = () => {
  const t = useT();

  const getPropertyLabel = (propertyCode: PropertyCode) => {
    if (
      PROPERTY_CODE_LABELS[propertyCode] === null ||
      PROPERTY_CODE_LABELS[propertyCode] === undefined
    ) {
      console.error(" add propertycode to get trabslate", propertyCode);
    }
    return t(PROPERTY_CODE_LABELS[propertyCode]);
  };

  return getPropertyLabel;
};
